import { render, staticRenderFns } from "./Ineligible.vue?vue&type=template&id=d5676d5e&"
import script from "./Ineligible.vue?vue&type=script&lang=ts&"
export * from "./Ineligible.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports